<template>
  <div class="afiliasi-card-wrapper">
    <SOSlotCard :card-type="`none`" v-for="(data, key) in listData" :key="`mutasiSaldo${key}`">
      <template v-slot:card_body>
        <div class="d-grid-2">
          <label class="m-d-0 f-16 f-c-black f-bold">
            {{ data.related_lable }}
          </label>
          <label class="m-d-0 j-self-end f-16 f-regular" :class="jenisTransaksi(data)">
            {{ jenisTransaksi(data) === "debit" ? "+" : "-" }} {{ nominalTransaksi(data) | currency }}
          </label>
          <label class="m-d-0 f-13">
            <!-- IJKL200215143710164 -->
            {{ data.related_id }}
          </label>
          <label class="m-d-0 j-self-end f-13">
            <!-- Sisa 800.000 -->
            {{ jenisTransaksi(data) === "kredit" ? "Sisa" : "Saldo menjadi" }} {{ data.saldo_akhir | currency }}
          </label>
          <label class="m-d-8 f-13">
            <!-- 23 Mei 2020 -->
            {{ `${$moment(data.created_at).format("DD MMM YYYY")}` }}
          </label>

          <label class="m-d-0 f-c-black f-regular f-12 gc-2">Keterangan:</label>
          <label class="m-d-0 f-c-midgrey f-regular f-12 gc-2">{{ data.keterangan }}</label>
        </div>
      </template>
    </SOSlotCard>
  </div>
</template>

<script>
import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

export default {
  name: "SOCardMutasiSaldo",
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  components: {
    SOSlotCard,
  },
  computed: {
    listData() {
      return this.dataList;
    },
    jenisTransaksi() {
      return (data) => {
        return data.debet > 0 ? "debit" : "kredit";
      };
    },
    nominalTransaksi() {
      return (data) => {
        return data.debet > 0 ? data.debet : data.kredit;
      };
    },
  },
};
</script>

<style scoped src="../styleScope.css"></style>

<style scoped>
.kredit {
  color: #eb5757;
}

.debit {
  color: #27ae60;
}
</style>
